import { properCase } from "LIB/formatters/text";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import {
  AS_REMOVED,
  BEYOND_ECON_REPAIR,
  INSPECTED,
  NEW,
  OVERHAULED,
  PARTS_UNIT,
  PHOTOS_RECEIVING_PACKAGING_INSPECTION,
  REPAIRED
} from "../Receiving/constants";

export const CONDITIONS = INCOMING_LINE_ITEMS.condition;
export const CONSIGNEE = "consignee";
export const EIN = "ein";
export const ROUTED_EXPORT = "routed_export";
export const USPPI = "usppi";

export const RESELLER = "reseller";
export const DIRECT_CONSUMER = "direct_consumer";
export const GOVERNMENT_ENTITY = "government_entity";
export const REPAIR_AND_RETURN = "repair_and_return";
export const OTHER = "other";

export const OUTGOING_AWB_NUMBER = "outgoing_awb_number";
export const READ_ONLY_COMPANY = "read_only_company";
export const READ_ONLY_COMPANY_UUID = "read_only_company_uuid";
export const READ_ONLY_INVENTORY_UUID = "read_only_inventory_uuid";
export const READ_ONLY_PART_NUMBER = "read_only_part_number";
export const READ_ONLY_PART_UUID = "read_only_part_uuid";
export const READ_ONLY_SERIAL_NUMBER = "read_only_serial_number";
export const SHIP_MULTIPLE_ITEM_IDS = "ship_multiple_item_ids";

export const ATTACHMENT_TYPES = {
  commercial_invoice: {
    label: "Commercial Invoice"
  },
  data_plate_dom_photos: {
    label: "Data Plate / DOM Photos"
  },
  external_link: {
    label: "External Link"
  },
  final_packaging_photos: {
    label: "Photos - Final Packaging"
  },
  photos_receiving_inspection: {
    label: "Photos - Shipping Inspection"
  },
  [PHOTOS_RECEIVING_PACKAGING_INSPECTION]: {
    label: "Photos - Shipping Packaging Inspection"
  },
  shipping_checklist: {
    label: "Shipping Checklist"
  }
};

export const LINK_MAPPINGS = {
  MR: "managed-repair-orders",
  MS: "mistake-shipments",
  RC: "inventories",
  PO: "purchase-orders",
  RMA: "rmas",
  RCORE: "purchase-orders",
  RO: "repair-orders",
  SO: "sales-orders",
  S: "shipping"
};

export const CONDITION_TYPES = {
  [AS_REMOVED]: {
    label: "As Removed",
    abbrev: "AR"
  },
  [BEYOND_ECON_REPAIR]: {
    label: "Beyond Econ. Repair",
    abbrev: "BR"
  },
  [INSPECTED]: {
    label: "Inspected",
    abbrev: "BT"
  },
  [NEW]: {
    label: "New",
    abbrev: "NE"
  },
  [OVERHAULED]: {
    label: "Overhauled",
    abbrev: "OH"
  },
  [PARTS_UNIT]: {
    label: "Parts Unit",
    abbrev: "PU"
  },
  [REPAIRED]: {
    label: "Repaired",
    abbrev: "SV"
  }
};

export const REPAIR_ORDER_CONSIGNEE_TYPES = {
  [REPAIR_AND_RETURN]: { label: properCase(REPAIR_AND_RETURN) }
};

export const CONSIGNEE_TYPES = {
  [RESELLER]: { label: "Reseller" },
  [DIRECT_CONSUMER]: { label: "Direct Consumer" },
  [GOVERNMENT_ENTITY]: { label: "Government Entity" },
  [OTHER]: { label: "Other/Unknown" }
};



// WEBPACK FOOTER //
// ./app/modules/Shipping/constants.js